import {
  CITATION_LIST_NAME_LOWER_SINGLE,
  CITATION_LIST_NAME_LOWER_PLURAL,
} from '@chegg-wt/core/constants/citations'
import { ProjectTypeKeys } from '@chegg-wt/core/constants/projectTypeKey'
import { Messages } from '@chegg-wt/core/types/core'

export default {
  [ProjectTypeKeys.ALL]: {
    title: 'Welcome to Cite This For Me™!', // TODO: objects should have same data structure
    description: `Get started by creating a ${CITATION_LIST_NAME_LOWER_SINGLE}.`,
  },
  [ProjectTypeKeys.STARRED]: {
    description: `You’ll find ${CITATION_LIST_NAME_LOWER_PLURAL} that you star here.`,
  },
  [ProjectTypeKeys.SEARCHING]: {
    description: `Hmm, no ${CITATION_LIST_NAME_LOWER_PLURAL} matched that search.`,
  },
  default: {
    description: `You haven’t moved ${CITATION_LIST_NAME_LOWER_PLURAL} into this folder.`,
  },
} as Messages

export const welcomeBannerMessage = `Welcome to the new Cite This For Me experience! Create 
        citations and check your paper for plagiarism.`
